import { render } from "./DuplicateDialog.vue?vue&type=template&id=1de0e43a&scoped=true"
import script from "./DuplicateDialog.vue?vue&type=script&lang=js"
export * from "./DuplicateDialog.vue?vue&type=script&lang=js"

import "./dialog.scss?vue&type=style&index=0&id=1de0e43a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de0e43a"]])

export default __exports__